import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import Index from "./pages/Index";
import { lazy, Suspense } from "react";
import NotFound from "./pages/NotFound";

// The desktop admin is not part of the public demo build: the literal env check lets Vite drop the chunk.
const AdminDesktopPage = import.meta.env.VITE_DEMO_MODE === "true" ? null : lazy(() => import("./pages/AdminDesktopPage"));
// The web panel (leads of the advisor bot + demo creator panel) ships only with the demo build.
const PanelPage = import.meta.env.VITE_DEMO_MODE === "true" ? lazy(() => import("./pages/PanelPage")) : null;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutos
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            {AdminDesktopPage && (
              <Route path="/admin" element={<Suspense fallback={null}><AdminDesktopPage /></Suspense>} />
            )}
            {PanelPage && (
              <Route path="/panel" element={<Suspense fallback={null}><PanelPage /></Suspense>} />
            )}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
